import { useEffect } from "react"
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb"
import CommanHeader from "../../components/Layout/CommanHeader"
import Footer from "../../components/Layout/Footer"
import Header from "../../components/Layout/Header"
import UserBar from "../../components/Userbar/UserBar"
import { Config } from "../../config/Config"
import { FAQAction } from "../../redux/Action/CmsPageAction"
import { useDispatch, useSelector } from "react-redux"
import Spinner from "../../components/Spinner"

const Faq = () => {
    const token = Config.IS_USER_LOGIN_TOKEN;
    const faqData = useSelector((state: any) => state.FaqGetState)
    const dispatch = useDispatch<any>();
    const { email, salon_name, buisness_images } = Config?.USER_DETAILS ? Config?.USER_DETAILS : "";
    const payload = { name: salon_name, email: email, image: buisness_images?.[0]?.file_path }

    useEffect(() => {
        dispatch(FAQAction({ user_type: "Salon" }))
    }, [])
    return (
        <>
            {
                !token && <CommanHeader />
            }

            {faqData?.loading ? <Spinner /> : ""}


            <main>
                {token && <Header payload={payload} />}
                <div className='container py-5'>
                    {/* {token && <Breadcrumb />} */}
                    <h1 className='title mb-4'>FAQ's</h1>
                    <div className="accordion  accordion-flush" id="accordionExample">
                        {
                            faqData?.data?.data?.map((item: any, index: any) => {
                                const targetId = `collapseOne${index}`;

                                return (
                                    <>
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#" + targetId} aria-expanded="true" aria-controls="collapseOne">
                                                    {item?.question}
                                                </button>
                                            </h2>
                                            <div id={targetId} className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <p>{item?.answer}</p>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                )
                            })
                        }

                    </div>
                </div>
            </main>
            <Footer />
        </>
    )
}

export default Faq